import React, { useState } from "react";
import "./faq.css";
import useIntersectionObserver from "../customHooks/useIntersectionObserver";

export default function FAQ() {
  const [activeIndex, setActiveIndex] = useState(null);
  const faqData = [
    {
      question: "How does Agent Trust calculate the AI Trust Score?",
      answer:
        "Agent Trust evaluates AI based on data integrity (diversity, security, and timeliness) and model performance (accuracy, fairness, and explainability), then assigns a weighted trust score.",
    },
    {
      question: "What industries benefit from AI Trust Scores?",
      answer:
        "AI Trust Score applies to Finance, Healthcare, Retail, Manufacturing, and Telecommunications, ensuring AI systems meet industry-specific trust and compliance standards.",
    },
    {
      question: "Can AI Trust Score detect AI biases?",
      answer:
        "Yes, AI Trust Score measures fairness by detecting biases in data and model predictions, helping organizations mitigate risks.",
    },
    {
      question: "How often should an AI Trust Score be updated?",
      answer:
        "AI Trust Score should be continuously monitored as models evolve and new data is introduced to ensure ongoing compliance and reliability.",
    },
    {
      question: "Is Agent Trust compliant with global AI regulations?",
      answer:
        "Agent Trust aligns with GDPR, HIPAA, and ISO 27001 standards, ensuring AI models adhere to strict compliance and ethical AI guidelines.",
    },
  ];

  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };
  const [ref, isVisible] = useIntersectionObserver({ threshold: 0.25 });

  return (
    <section
      className={`faq-section ${isVisible ? "section-animation" : ""}`}
      ref={ref}
      id="six"
    >
      <div className="container">
        <div className="section-heading">
          <div className="heading-tag">
            <span>FAQ</span>
          </div>
          <div className="heading-description">
            <h2>Frequently Asked Questions</h2>
            <p>Everything you need to know</p>
          </div>
        </div>

        <div className="accordion">
          {faqData.map((item, index) => (
            <div className="accordion-item" key={index}>
              <button
                id={`accordion-button-${index + 1}`}
                aria-expanded={activeIndex === index ? "true" : "false"}
                onClick={() => toggleAccordion(index)}
              >
                <span className="accordion-title">{item.question}</span>
                <span className="icon" aria-hidden="true"></span>
              </button>
              <div className="accordion-content">
                <p>{item.answer}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
